import {Injectable} from '@angular/core';
import { AbstractLocalStorageService } from './local-storage.abstract.service';
import {LocalStorageKeys} from './local-storage.enum';

@Injectable({
  providedIn: 'root',
})

export class LocalStorageService implements AbstractLocalStorageService {

  clear(key: LocalStorageKeys): void {
    localStorage.removeItem(key as string);
  }

  get<T>(key: LocalStorageKeys): T {
    let item = localStorage.getItem(key as string);
    if (item)
      return JSON.parse(item) as T;
    else
      throw (new Error('item was not found in local storage, key: '+ key));
  }

  // same as get without exception
  getSecured<T>(key: LocalStorageKeys): T | undefined {
    let item :string|null = localStorage.getItem(key as string);

    if (item != undefined && item !== null){
      return JSON.parse(item) as T;
    }
    else{
      return undefined;
    }
  }

  write<T>(key: LocalStorageKeys, value: T): void {
    localStorage.setItem(key as string, JSON.stringify(value));
  }
}
